<script>
export default {
  name: 'CustomFile',
  inheritAttrs: false, // Prevents attributes from being applied automatically to the root element
  computed: {
    // This value is accessed by the parent component through $refs
    value () {
      return this.$attrs.value
    }
  }
}
</script>

<template>
  <b-form-file
    v-bind="$attrs"
    v-on="$listeners"
    :placeholder="$attrs.placeholder || 'Choose a custom file'"
    :drop-placeholder="$attrs.dropPlaceholder || 'Drop file here...'"
    :class="{
      'g-file-input': true,
      'g-file-input-empty': !Boolean($attrs.value),
    }"
    @input="$emit('input', $event)"
  />
</template>

<style lang="scss">
.g-file-input {
  &.g-file-input-empty .custom-file-label {
    color: $fontColor2;
  }

  .custom-file-label {
    padding-right: 34px;
    display: block;
    font-family: "Ubuntu", sans-serif;

    &::after {
      content: 'attachment' !important;
      height: auto;
      border-left: 0;
      padding: 6px 10px;
      background: transparent;
      color: $iconColor2;
      font-family: 'Material Symbols Outlined';
      font-size: 18px;
      line-height: 1;
      -webkit-font-feature-settings: 'liga';
    }

    .form-file-text {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
